function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// src/color.ts
import { getCSSVar } from "@chakra-ui/styled-system";
import { toHex, parseToRgba, transparentize as setTransparency, mix, darken as reduceLightness, lighten as increaseLightness, getContrast, parseToHsla, hsla, getLuminance } from "color2k";

// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function dlv_es_default(t, e, l, n, r) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++) t = t ? t[e[n]] : r;
  return t === r ? l : t;
}

// src/color.ts
var isEmptyObject = function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
};
var getColor = function getColor(theme, color, fallback) {
  var hex = dlv_es_default(theme, "colors.".concat(color), color);
  try {
    toHex(hex);
    return hex;
  } catch (_unused) {
    return fallback != null ? fallback : "#000000";
  }
};
var getColorVar = function getColorVar(theme, color, fallback) {
  var _a;
  return (_a = getCSSVar(theme, "colors", color)) != null ? _a : fallback;
};
var getBrightness = function getBrightness(color) {
  var _parseToRgba = parseToRgba(color),
    _parseToRgba2 = _slicedToArray(_parseToRgba, 3),
    r = _parseToRgba2[0],
    g = _parseToRgba2[1],
    b = _parseToRgba2[2];
  return (r * 299 + g * 587 + b * 114) / 1e3;
};
var tone = function tone(color) {
  return function (theme) {
    var hex = getColor(theme, color);
    var brightness = getBrightness(hex);
    var isDark2 = brightness < 128;
    return isDark2 ? "dark" : "light";
  };
};
var isDark = function isDark(color) {
  return function (theme) {
    return tone(color)(theme) === "dark";
  };
};
var isLight = function isLight(color) {
  return function (theme) {
    return tone(color)(theme) === "light";
  };
};
var transparentize = function transparentize(color, opacity) {
  return function (theme) {
    var raw = getColor(theme, color);
    return setTransparency(raw, 1 - opacity);
  };
};
var whiten = function whiten(color, amount) {
  return function (theme) {
    var raw = getColor(theme, color);
    return toHex(mix(raw, "#fff", amount));
  };
};
var blacken = function blacken(color, amount) {
  return function (theme) {
    var raw = getColor(theme, color);
    return toHex(mix(raw, "#000", amount / 100));
  };
};
var darken = function darken(color, amount) {
  return function (theme) {
    var raw = getColor(theme, color);
    return toHex(reduceLightness(raw, amount / 100));
  };
};
var lighten = function lighten(color, amount) {
  return function (theme) {
    var raw = getColor(theme, color);
    toHex(increaseLightness(raw, amount / 100));
  };
};
var contrast = function contrast(fg, bg) {
  return function (theme) {
    return getContrast(getColor(theme, bg), getColor(theme, fg));
  };
};
var isAccessible = function isAccessible(textColor, bgColor, options) {
  return function (theme) {
    return isReadable(getColor(theme, bgColor), getColor(theme, textColor), options);
  };
};
function isReadable(color1, color2) {
  var wcag2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    level: "AA",
    size: "small"
  };
  var _a, _b;
  var readabilityLevel = readability(color1, color2);
  switch (((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")) {
    case "AAsmall":
    case "AAAlarge":
      return readabilityLevel >= 4.5;
    case "AAlarge":
      return readabilityLevel >= 3;
    case "AAAsmall":
      return readabilityLevel >= 7;
    default:
      return false;
  }
}
function readability(color1, color2) {
  return (Math.max(getLuminance(color1), getLuminance(color2)) + 0.05) / (Math.min(getLuminance(color1), getLuminance(color2)) + 0.05);
}
var complementary = function complementary(color) {
  return function (theme) {
    var raw = getColor(theme, color);
    var hsl = parseToHsla(raw);
    var complementHsl = Object.assign(hsl, [(hsl[0] + 180) % 360]);
    return toHex(hsla.apply(void 0, _toConsumableArray(complementHsl)));
  };
};
function generateStripe() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1rem";
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "rgba(255, 255, 255, 0.15)";
  return {
    backgroundImage: "linear-gradient(\n    45deg,\n    ".concat(color, " 25%,\n    transparent 25%,\n    transparent 50%,\n    ").concat(color, " 50%,\n    ").concat(color, " 75%,\n    transparent 75%,\n    transparent\n  )"),
    backgroundSize: "".concat(size, " ").concat(size)
  };
}
var randomHex = function randomHex() {
  return "#".concat(Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0"));
};
function randomColor(opts) {
  var fallback = randomHex();
  if (!opts || isEmptyObject(opts)) {
    return fallback;
  }
  if (opts.string && opts.colors) {
    return randomColorFromList(opts.string, opts.colors);
  }
  if (opts.string && !opts.colors) {
    return randomColorFromString(opts.string);
  }
  if (opts.colors && !opts.string) {
    return randomFromList(opts.colors);
  }
  return fallback;
}
function randomColorFromString(str) {
  var hash = 0;
  if (str.length === 0) return hash.toString();
  for (var i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  var color = "#";
  for (var j = 0; j < 3; j += 1) {
    var value = hash >> j * 8 & 255;
    color += "00".concat(value.toString(16)).substr(-2);
  }
  return color;
}
function randomColorFromList(str, list) {
  var index = 0;
  if (str.length === 0) return list[0];
  for (var i = 0; i < str.length; i += 1) {
    index = str.charCodeAt(i) + ((index << 5) - index);
    index = index & index;
  }
  index = (index % list.length + list.length) % list.length;
  return list[index];
}
function randomFromList(list) {
  return list[Math.floor(Math.random() * list.length)];
}
export { getColor, getColorVar, tone, isDark, isLight, transparentize, whiten, blacken, darken, lighten, contrast, isAccessible, isReadable, readability, complementary, generateStripe, randomColor };